<template>
  <div>
    <commonChat :chatType="0"></commonChat>
  </div>
</template>

<script>
  import commonChat from '@/views/IM/model/commonChat.vue'
  export default {
    name: 'intelligentChat',
    components: { commonChat}
  }
</script>
